import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styles from '../styles/ProjectDetails.module.css';
import Section from './Section';


export default function ProjectDetails() {
    const location = useLocation();
    const { projects } = location.state;
    console.log(projects);
    console.log(location);
    useEffect(() => {
      window.scrollTo(0,0)
    })
  return (
    <section id="home">
      <div className={styles.projectDetails}>
      <div className={styles.banner} >
        <h2>{projects.title}</h2>
        <p>{projects.description}</p>
        <div>
          <a href={projects.url} target="_blank" rel="noreferrer noopener">
              <button type="button">LIVE LINK</button>    
          </a>
          {'  '}
          {projects.githubLink ?<a href={projects.githubLink} target="_blank" rel="noreferrer noopener">
              <button type="button">GITHUB LINK</button>
          </a> : null }
        </div>          
      </div>
      <hr className={styles.break} />
      <div className={styles.section}>
        {projects.section? projects.section.map((section) => (
          <section>
            <Section subheader={section.subheader}  description={section.description} />
          </section>         
        )) : null}
      </div>  
      
      <div className={styles.tools}>
        <h4>Tools used</h4>
        <div className={styles.toolDisplay}>
        {projects.tools.map((tool) =>             
              <div className={styles.tool}>{tool}</div>
          )}
         </div>   
      </div>    
    </div>

    </section>
    
  )
}
